'use client';

import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Input,
  InputGroup,
  InputRightElement,
  Box,
  Text,
  Image
} from '@chakra-ui/react';
import EyeOff from '../../../../assets/eye-off.svg';
import EyeOn from '../../../../assets/eye-disabled-icon.svg';
import CloseModalIcon from '../../../../assets/close-modal-icon.svg';
import RightArrowIcon from '../../../../assets/arrow-right-white-icon.svg';
import Button from '../../../Button';

const VerifyPasswordModal = ({
  isOpen,
  title,
  desc,
  inputLabel,
  placeholder,
  btnText,
  isLoading,
  errorMessage,
  setErrorMessage,
  onClick,
  onClose
}: {
  isOpen: boolean;
  title?: string;
  desc?: string;
  inputLabel?: string;
  placeholder?: string;
  btnText?: string;
  isLoading?: boolean;
  errorMessage?: string;
  setErrorMessage?: (value: any) => void;
  onClick: (value: string) => void;
  onClose: () => void;
}) => {
  const [pw, setPw] = useState<string>('');

  const [showPw, setShowPw] = useState<boolean>(false);

  const onVerify = (e: any) => {
    e.preventDefault();
    onClick(pw);
  };

  const onChange = (e: any) => {
    setPw(e.target.value);

    setErrorMessage && setErrorMessage('');
  };

  const onShowPassword = () => {
    setShowPw(!showPw);
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay bg={'jet-black'} />
      <ModalContent p={'20px 15px'} bgColor={'#FAFAFA'} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onClose}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody mt="24px" p={0}>
          <p className="text-[18px] font-[400] mt-3">{desc}</p>
          <form className="mt-[24px]">
            <Box mb={'1.5rem'}>
              <Text
                mb={{ base: '0.375rem', md: '0.5rem' }}
                fontSize={'sm'}
                fontWeight={900}
                color="jet-black"
              >
                {inputLabel}
              </Text>
              <InputGroup rounded="0.75rem">
                <Input
                  bg="light.100 "
                  p="1rem 2.5rem 1rem 1.25rem"
                  rounded="0.5rem"
                  type={showPw ? 'text' : 'password'}
                  placeholder={placeholder}
                  _focusVisible={{ borderColor: 'twygs-green' }}
                  onChange={onChange}
                />
                <InputRightElement h={'3.6rem'} pr="1rem">
                  <Image w="1rem" alt="" src={showPw ? EyeOn : EyeOff} onClick={onShowPassword} />
                </InputRightElement>
              </InputGroup>
              {!!errorMessage && <Text color={'other.200'}>{errorMessage}</Text>}
            </Box>
            <Button className="w-full h-[42px] !text-base" onClick={onVerify} type="submit">
              Next
              <Image
                className="w-[24px] h-[24px] ml-[12px] cursor-pointer"
                src={RightArrowIcon}
                alt=""
              />
            </Button>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default VerifyPasswordModal;
